import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/illustrations/gpu.svg'


const _hoisted_1 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "ma-4 mpc-gpu mx-auto" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_img, {
            src: _imports_0,
            height: "44px",
            width: "48px",
            class: "mx-auto"
          }),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "token-text-h4 mb-2 text-center" }, " GPU nodes ", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "token-text-regular mb-6 text-center" }, " Do you need to run AI workloads? ", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_CustomButton, {
              class: "full-width mb-2",
              level: _ctx.$enums.ButtonLevels.Secondary,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:requireGPU', true)))
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" Yes ")
              ])),
              _: 1
            }, 8, ["level"]),
            _createVNode(_component_CustomButton, {
              class: "full-width mb-2",
              level: _ctx.$enums.ButtonLevels.Secondary,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:requireGPU', false)))
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" No ")
              ])),
              _: 1
            }, 8, ["level"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}